module.exports = __webpack_public_path__ + "static/img/dcc_bg1.2e9e4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student/dcc_bg1.png
// module id = Im6D
// module chunks = 1